import { KhrService } from 'src/services/khr.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const KHR_NEW_CARE_SUCCESS = 'KHR:NEW_CARE_SUCCESS'
export const KHR_LIST_SUCCESS = 'KHR:FIND_ALL_SUCCESS'
export const KHR_LIST_FAILD = 'KHR:FIND_ALL_FAILD'
export const KHR_COUNT_ASSIGN_SUCCESS = 'KHR:COUNT_ASSIGN_SUCCESS'
export const KHR_COUNT_ASSIGN_FAILD = 'KHR:COUNT_ASSIGN_FAILD'

export const KHR_CREATE_SUCCESS = 'KHR:CREATE_SUCCESS'
export const KHR_CREATE_FAILD = 'KHR:CREATE_FAILD'

export const KHR_IMPORT_SUCCESS = 'KHR:IMPORT_SUCCESS'
export const KHR_SAVE_SUCCESS = 'KHR:SAVE_SUCCESS'
export const KHR_SAVE_FAILD = 'KHR:SAVE_SUCCESS'

export const KHR_DEL_SUCCESS = 'KHR:DEL_SUCCESS'
export const KHR_DEL_FAILD = 'KHR:DEL_FAILD'

export const KHR_ONE_SUCCESS = 'KHR:FIND_ONE_SUCCESS'
export const KHR_ONE_FAILD = 'KHR:FIND_ONE_FAILD'

export const KHR_HISTORY_LIST_SUCCESS = 'KHR:HISTORY_FIND_ALL_SUCCESS'
export const KHR_HISTORY_LIST_FAILD = 'KHR:HISTORY_FIND_ALL_FAILD'

export const KHR_UPDATE_FILTER = 'KHR:UPDATE_FILTER'

export const KhrAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    updateFilter,
}

function updateFilter(payload) {
    return { type: KHR_UPDATE_FILTER, data: payload }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            KhrService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(KhrAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: KHR_CREATE_SUCCESS, data } }
    function failure(error) { return { type: KHR_CREATE_FAILD, error } }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        KhrService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHR_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: KHR_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { khr } = getState()
        dispatch(AppAction.appLoading(true));
        KhrService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...khr.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHR_LIST_SUCCESS, data } }
    function failure(error) { return { type: KHR_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { khr } = getState();
        const page = khr && typeof khr.filter !== 'undefined' && khr.filter && typeof khr.filter.page !== 'undefined' ? khr.filter.page : 0;
        const limit = khr && typeof khr.filter !== 'undefined' && khr.filter && typeof khr.filter.limit !== 'undefined' ? khr.filter.limit : 10;
        KhrService.findAll(page, limit, khr.filter).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                const oldItems = khr.items;
                const rsDataValues = rs.data.values;

                var uniqueItems = oldItems;
                for (var i = limit * page; i < limit * page + limit; i++) {
                    if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                        uniqueItems[i] = rsDataValues[i - limit * page];
                    } else if (typeof uniqueItems[i] !== 'undefined') {
                        delete uniqueItems[i];
                    }
                }
                
                dispatch(success({
                    items: uniqueItems,
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHR_LIST_SUCCESS, data } }
    function failure(error) { return { type: KHR_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: KHR_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            KhrService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(KhrAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: KHR_SAVE_SUCCESS, data } }
    function failure(error) { return { type: KHR_SAVE_FAILD, error } }
}

function create(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            // Perform your asynchronous operation (e.g., API call)
            KhrService.create(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(KhrAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            });
        });
    };
    function success(data) { return { type: KHR_CREATE_SUCCESS, data } }
    function failure(error) { return { type: KHR_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        KhrService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(KhrAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHR_CREATE_SUCCESS, data } }
    function failure(error) { return { type: KHR_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        KhrService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(KhrAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHR_DEL_SUCCESS, data } }
    function failure(error) { return { type: KHR_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        KhrService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHR_ONE_SUCCESS, data } }
    function failure(error) { return { type: KHR_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        KhrService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(KhrAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { khr } = getState()
        dispatch(AppAction.appLoading(true));
        KhrService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...khr.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: KHR_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: KHR_HISTORY_LIST_FAILD, error } }
}